export default {
    primary: '#db244b',
    secondary: '#FFFFFF',
    grey: '#BFBFBF',
    yellow: '#e5a800',
    blue: "#1a2a44"
    // Add other colors as needed
  };
  